<template>
  <input
    id="select-options-filter-input"
    ref="input"
    v-model="model"
    type="text"
    :placeholder="placeholder"
    class="w-full p-2 text-base md:text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
    @click="focus"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";

// The one search field a SelectInput has, whether it sits in the anchored
// panel's filter row or in a bottom sheet's header, so the id the E2E helpers
// key on lives in exactly one place. 16px below `md` on purpose: iOS Safari
// zooms the whole page into a focused input with a smaller font.
defineProps<{ placeholder: string }>();
const model = defineModel<string>({ required: true });

const input = ref<HTMLInputElement | null>(null);

// Exposed so a sheet can move the caret here as soon as it has opened.
const focus = () => input.value?.focus();

defineExpose({ focus });
</script>
